import type { Dtos } from "@inrev/common";
import { Option } from "@inrev/core";
import { match } from "ts-pattern";

type Report = Dtos.Admin.SuretyAccount.Get.Response["companies"][number]["creditReports"][number];

/** Why a pull failed and what to do next. None for a successful report or an unknown reason. */
export const companyCreditFailureMessage = (report: Report | undefined): string | undefined => {
	if (Option.isNone(report) || report.success) return undefined;
	return match(report.failureReason)
		.with(
			"insufficient_data",
			() => "Insufficient data to pull credit. Add an address and re-pull.",
		)
		.with(
			"not_found",
			() => "The bureau has no credit file matching this company's name and address.",
		)
		.with(
			"vendor_error",
			() => "The credit bureau returned an error. Try pulling the report again later.",
		)
		.with(undefined, () => undefined)
		.exhaustive();
};
